import React, { useState, useEffect } from "react";
import {
  Box,
  Popover,
  List,
  Typography,
  ListItem,
  makeStyles
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DateFnsUtils from "@date-io/date-fns";
import SmallSearchBox from "../../common/SmallSearchBox";
import { getDateValue } from "../../../utils/helpers";
import { connect } from "react-redux";
import { useSnackbar } from "notistack";
import API from "../../../utils/axios";
import { getProjectDetails } from "../../../store/actions/project";

const usePopoverStyles = makeStyles(theme => ({
  listWrapper: {
    height: 200,
    overflow: "auto",
    borderBottom: "1px solid #eee",
    borderTop: "1px solid #eee"
  },
  noProjects: {
    textAlign: "center",
    fontSize: "0.875rem",
    marginTop: theme.spacing(1)
  },
  searchBox: {
    width: "100%"
  },
  menuItem: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&:hover": {
      backgroundColor: "#eee"
    }
  },
  text: {
    fontSize: "15px",
    lineHeight: "18px",
    fontWeight: 400,
    maxWidth: 228
  },
  projectDate: {
    fontSize: "14px",
    lineHeight: "16px",
    fontWeight: 500,
    color: "#808080"
  },
  btnMenuItem: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#F3F4FF"
    },
    "& svg": {
      paddingRight: theme.spacing(2),
      color: theme.palette.primary.main,
      fontSize: "24px !important"
    }
  }
}));

const dateFns = new DateFnsUtils();

function SelectProjectPopover({
  appProjects,
  handleClose,
  anchorEl,
  handleOpen,
  getProjectDetails,
  selected,
  setSelected,
  setLoadingCircle
}) {
  const [searchInputValue, setSearchInputValue] = useState("");
  const [filteredProjects, setFilteredProjects] = useState([]);

  const popoverClasses = usePopoverStyles();
  const { enqueueSnackbar } = useSnackbar();

  const open = Boolean(anchorEl);
  const id = open ? "projects-popover" : undefined;

  const handleFilter = (project, value) => {
    return (
      (project.name || "").toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  };

  const handleSearchChange = val => {
    setSearchInputValue(val);
  };

  useEffect(() => {
    setFilteredProjects(
      appProjects.filter(project => handleFilter(project, searchInputValue))
    );
  }, [appProjects, searchInputValue]);

  const handleStopMoveToProject = project => {
    const body = selected.map(item => {
      const { id, tableData, ...rest } = item;
      return {
        ...rest,
        stop: {
          ...rest.stop
          // units: rest.stop.quantity
          //   ? [
          //       {
          //         name: "",
          //         barcode: "",
          //         note: "",
          //         quantity: rest.stop.quantity
          //       }
          //     ]
          //   : []
        }
      };
    });

    setLoadingCircle(true);
    API.post(`v1/apps/projects/${project.id}`, body)
      .then(res => {
        setSelected([]);
        if (project.id === sessionStorage.currentProject) {
          getProjectDetails(sessionStorage.currentProject);
        }
        enqueueSnackbar(
          `Selected stop${selected.length > 1 ? "s" : ""} moved to "${
            project.name
          }".`
        );
      })
      .catch(error => {
        console.dir(error);
        enqueueSnackbar("Something went wrong");
      })
      .finally(() => setLoadingCircle(false));
  };

  return (
    <>
      <Popover
        id={id}
        open={open}
        PaperProps={{
          style: { width: "360px", marginTop: "4px" }
        }}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left"
        }}
      >
        <Box p={1}>
          <SmallSearchBox
            className={popoverClasses.searchBox}
            searchText={searchInputValue}
            onSearchChanged={handleSearchChange}
            ariaLabel="Search projects"
            dataCy="projects-search"
          />
        </Box>

        <div className={popoverClasses.listWrapper}>
          <List>
            {filteredProjects.length ? (
              filteredProjects.map(project => (
                <ListItem
                  button
                  onClick={() => handleStopMoveToProject(project)}
                  className={popoverClasses.menuItem}
                  key={project.id}
                >
                  <Typography noWrap className={popoverClasses.text}>
                    {project.name}
                  </Typography>
                  <Typography noWrap className={popoverClasses.projectDate}>
                    {dateFns.format(
                      new Date(getDateValue(project.project_date)),
                      "dd/MM/yyyy"
                    )}
                  </Typography>
                </ListItem>
              ))
            ) : (
              <Typography className={popoverClasses.noProjects} noWrap>
                No projects to display
              </Typography>
            )}
          </List>
        </div>
        <List>
          <ListItem className={popoverClasses.btnMenuItem} onClick={handleOpen}>
            <AddIcon />
            <Typography color="primary" className={popoverClasses.text}>
              New project
            </Typography>
          </ListItem>
        </List>
      </Popover>
    </>
  );
}

const mapStateToProps = state => ({
  appProjects: state.account.appProjects.filter(
    project => !["expired", "finished"].includes(project.status.toLowerCase())
  )
});

export default connect(mapStateToProps, { getProjectDetails })(
  SelectProjectPopover
);
